import type { ReactNode } from 'react'
import { AuLabelsContext, type AuLabels } from './labels'

/**
 * Reemplaza el catálogo de textos de la capa para todo lo que tenga adentro. Se monta una vez, en
 * la raíz del host, y es **opcional**: sin él rige `esLabels`.
 *
 * Exige el catálogo **completo** (`AuLabels`, no `Partial`) a propósito: cuando la capa suma un
 * texto nuevo, un host que traduce deja de compilar hasta traducirlo, en vez de mostrar ese texto en
 * español sin que nadie se entere. Para cambiar unas pocas entradas, se parte de `esLabels`, **fuera
 * del render**:
 *
 * ```tsx
 * const labels: AuLabels = { ...esLabels, chip: { remove: 'Eliminar' } }
 * <AuLabelsProvider labels={labels}>
 * ```
 *
 * La identidad del objeto importa: es el valor del contexto, así que uno nuevo en cada render del
 * host vuelve a renderizar a todos los componentes que leen el catálogo. Una constante de módulo, o un
 * `useMemo` que dependa solo del idioma, lo evita.
 *
 * La capa no importa ninguna librería de i18n: el host arma el objeto con la que use y lo pasa
 * acá. Cómo hacerlo, en `src/au/LABELS.md`.
 */
export function AuLabelsProvider({ labels, children }: { labels: AuLabels; children: ReactNode }) {
  return <AuLabelsContext.Provider value={labels}>{children}</AuLabelsContext.Provider>
}
